import { FormGroup, Input, Label } from "reactstrap";
import { RADIO_DATAS } from "../../../Data/Blog";
import { PostType } from "../../../Constant";

const RadioTypeForm = () => {
 
  return (
    <FormGroup>
      <Label className="mb-2" check>{PostType}:</Label>
      <div className="m-checkbox-inline">
        {RADIO_DATAS.map((data, index) => (
          <Label for={`edo-ani-${index}`} key={index} check>
            <Input
              className="radio_animated"
              id={`edo-ani-${index}`}
              type="radio"
              name="rdo-ani"
              defaultChecked={data.defaultChecked}
            />
            {data.text}
          </Label>
        ))}
      </div>
    </FormGroup>
  );
};

export default RadioTypeForm;
